module.exports = __webpack_public_path__ + "static/media/2025-Sports-Masterclass-Desktop-Banner@1x.812fa12b.webp";